var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWatchLaterFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 36.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.769,1.929H-9.978v-12.2A1.852,1.852,0,0,1-8.11-12.137a1.788,1.788,0,0,1,1.868,1.868v8.462H2.769A1.852,1.852,0,0,1,4.637.06,1.788,1.788,0,0,1,2.769,1.929m3.3-15.6A19.943,19.943,0,0,0-8.11-19.5a20.134,20.134,0,0,0-14.176,5.824A20.509,20.509,0,0,0-28,.5a20.134,20.134,0,0,0,5.824,14.176A19.943,19.943,0,0,0-8,20.5,20.134,20.134,0,0,0,6.176,14.676,19.943,19.943,0,0,0,12,.5,20.046,20.046,0,0,0,6.066-13.676",
    transform: "translate(28 -16.9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWatchLaterFill);
export default __webpack_public_path__ + "static/media/icon-watch-later-fill.ad8bca72.svg";
export { ForwardRef as ReactComponent };